<div class="payments-section">
  <ssg-expander [open]="allExpanded || sectionExpanded" (stateChanged)="sectionExpanded = $event" [expandable]="paymentAggregateInfo.hasPayments">
    <div expander-content>
      <div class="payments-header" data-automation="at-a-glance-payments-header">
        <ukg-popover #paymentsTooltip class="at-a-glance-tooltip" type="custom">
          <span>
            <b translate>AT_A_GLANCE.PAYMENTS_HELP_TITLE</b><br /><br />
            <p [innerHtml]=" 'AT_A_GLANCE.PAYMENTS_HELP_TEXT' | translate "></p>
          </span>
        </ukg-popover>
        <div class="header-position">
        <strong class="section-title">{{ 'COMMON.PAYMENTS' | translate}} </strong><span class="heading-icon-spacing clickable header-position"><ukg-icon (click)="paymentsTooltip.present($event.target)"  name="help"></ukg-icon></span>
      </div>
      </div>
    </div>
    <div expanded-content class="text-muted">
      <ukg-popover #multiplePaymentsTooltip class="at-a-glance-tooltip" type="custom">
        <span>
          <div *ngIf="paymentAggregateInfo.paymentFileInfos.length > 0 && paymentAggregateInfo.paymentFileInfos.length <= 20">
            <div *ngIf="paymentAggregateInfo.paymentFileInfos.length > 1">
              <b><span> {{ 'AT_A_GLANCE.DIRECT_DEPOSIT_FILES_SENT_ON' | translate:{number:paymentAggregateInfo.paymentFileInfos.length} }}</span></b> <br />
              <div *ngFor="let dateThenCountPair of fileCountByDate">
                <span>{{ 'AT_A_GLANCE.DIRECT_DEPOSIT_DATE_COUNT' | translate:{ date : dateThenCountPair.date | ultishortdate: 'L', count: dateThenCountPair.numberFilesSent} }}</span>
              </div>
            </div>
            <div *ngIf="paymentAggregateInfo.paymentFileInfos.length === 1">
              <b><span> {{ 'AT_A_GLANCE.DIRECT_DEPOSIT_FILE_SENT_ON' | translate:{number: paymentAggregateInfo.paymentFileInfos.length} }}</span></b> <br />
              <div *ngFor="let dateThenCountPair of fileCountByDate">
                <span>{{dateThenCountPair.date | ultishortdate: 'L'}} </span>
              </div>
            </div>

          </div>

          <div *ngIf="paymentAggregateInfo.paymentFileInfos.length > 20">
            <!-- If there are more than 20 DDs and some were sent on different dates, display a range instead of a listing-->
            <div *ngIf="fileCountByDate.length > 1">
              <b><span> {{ 'AT_A_GLANCE.DIRECT_DEPOSIT_FILES_SENT_BETWEEN' | translate:{number: paymentAggregateInfo.paymentFileInfos.length} }}</span></b> <br />
              <span>{{ 'AT_A_GLANCE.DIRECT_DEPOSIT_FILES_SENT_BETWEEN_DATES' | translate:{ fromDate : fileCountByDate[fileCountByDate.length-1].date | ultishortdate: 'L', toDate: fileCountByDate[0].date | ultishortdate: 'L'} }}</span>
            </div>

            <!-- If there are more than 20 DDs and they are all on the same date, don't show show the number of files next to the date in parentheses-->
            <div *ngIf="fileCountByDate.length === 1">
              <b><span> {{ 'AT_A_GLANCE.DIRECT_DEPOSIT_FILES_SENT_ON' | translate:{number: paymentAggregateInfo.paymentFileInfos.length} }}</span></b> <br />
              <span>{{fileCountByDate[0].date | ultishortdate: 'L'}}</span>
            </div>
          </div>
        </span>
      </ukg-popover>

      <!--Display files sent-->
      <div class="payments-gap header-position" *ngIf="paymentAggregateInfo.paymentFileInfos.length > 1">
          <ukg-icon name="status-finished" class="check-circle" size="s"></ukg-icon>
          <span class="help-cursor-hover header-position section-title" (click)="multiplePaymentsTooltip.present($event.target)">{{ 'AT_A_GLANCE.DIRECT_DEPOSIT_FILES_SENT' | translate:{number: paymentAggregateInfo.paymentFileInfos.length} }}</span>
      </div>

      <div class="payments-gap header-position"  *ngIf="paymentAggregateInfo.paymentFileInfos.length === 1 && paymentAggregateInfo.possibleOutstandingPaymentFiles === false">
          <ukg-icon name="status-finished" class="check-circle" size="s"></ukg-icon>
          <span class="help-cursor-hover header-position section-title" (click)="multiplePaymentsTooltip.present($event.target)" translate>AT_A_GLANCE.DIRECT_DEPOSIT_FILE_SENT</span>
      </div>

      <div class="payments-gap header-position"  *ngIf="paymentAggregateInfo.paymentFileInfos.length === 1 && paymentAggregateInfo.possibleOutstandingPaymentFiles === true">
          <ukg-icon name="status-finished" class="check-circle" size="s" ></ukg-icon>
          <span  class="help-cursor-hover header-position section-title" (click)="multiplePaymentsTooltip.present($event.target)">{{ 'AT_A_GLANCE.DIRECT_DEPOSIT_FILE_WITH_NUM_SENT' | translate:{number: paymentAggregateInfo.paymentFileInfos.length} }}</span>
      </div>

      <div class="payments-gap header-position"
        *ngIf="paymentAggregateInfo.hasPayments && paymentAggregateInfo.paymentFileInfos.length === 0 && paymentAggregateInfo.possibleOutstandingPaymentFiles === false">
        <span class="header-position section-title"
          translate>AT_A_GLANCE.DIRECT_DEPOSIT_FILE_NOT_APPLICABLE</span>
      </div>
      <!--Handle files not sent-->
      <div class="payments-gap header-position section-title"
        *ngIf="paymentAggregateInfo.paymentFileInfos.length === 0 && paymentAggregateInfo.possibleOutstandingPaymentFiles === true"
        translate>AT_A_GLANCE.DIRECT_DEPOSIT_FILES_NOT_SENT</div>
      <div class="payments-gap header-position section-title" *ngIf="paymentAggregateInfo.paymentFileInfos.length > 0 && paymentAggregateInfo.possibleOutstandingPaymentFiles === true"
        translate>AT_A_GLANCE.DIRECT_DEPOSIT_FILES_ADDITIONAL_NOT_SENT</div>
    </div>
  </ssg-expander>
  <div class="payments-gap header-position" *ngIf="!paymentAggregateInfo.hasPayments"
    class="text-muted text-center text-sm text-no-data" data-automation="at-a-glance-payment-no-data-display" translate>
    AT_A_GLANCE.NO_PAYMENTS_TO_DISPLAY
  </div>
</div>